<template>
  <CollarLeashPersonalizePreview
    v-if="previewOnly"
    :base-tag-svg-img-path="baseSvgImgPath"
    :phone-number="personalizationDetails.phone || ''"
    :home-safe-id="selectedPet && selectedPet.idCode ? selectedPet.idCode : 'U237JC9Z'"
    :show-labels="previewShowLabels"
    :height="previewHeight"
    :scale="previewScale"
    :personalization-selected="personalizationDetails.selected"
  />
  <section v-else class="mt-2">
    <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
    <h2 v-html="$t(titleKey, [Number(price)])" />
    <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
    <h3 class="text-dark mt-n2 mb-3" v-html="$t(!isAdmin ? 'collarPersonalize.info.default' : 'collarPersonalize.info.admin')" />
    <CollarLeashPersonalizePreview
      v-if="!hidePreview"
      :base-tag-svg-img-path="baseSvgImgPath"
      :phone-number="personalizationDetails.phone || ''"
      :home-safe-id="selectedPet && selectedPet.idCode ? selectedPet.idCode : 'U237JC9Z'"
      :height="previewHeight"
      :scale="previewScale"
      :personalization-selected="personalizationDetails.selected"
    />
    <ValidationObserver ref="p_personalize_form" v-slot="{ validated }" slim>
      <b-form-group id="personalized-checkbox-group" class="mt-3" label-for="product-style-personalized">
        <div>
          <b-form-checkbox
            id="product-style-personalized"
            v-model="personalizationDetails.selected"
            size="lg"
            style="z-index: 1029; display: grid"
            @input="$emit('input', personalizationDetails)"
            @change="onPersonalizationSelectionChange"
          >
            <!-- eslint-disable-next-line vue/no-v-html (Make sure it's always hard-coded) -->
            <h2
              class="text-primary font-weight-bold"
              :class="{
                'text-light': !personalizationDetails.selected && personalizationDetails.selected !== null,
              }"
              v-html="$t(!isAdmin ? 'collarPersonalize.option.default' : 'collarPersonalize.option.admin')"
            />
          </b-form-checkbox>
          <section v-if="personalizationDetails.selected" class="mt-1">
            <b-row>
              <b-col cols="12" xl="6" :class="isLoggedIn ? '' : 'd-flex align-items-center grow-1'">
                <DpSelect
                  v-if="isLoggedIn"
                  v-model="personalizationDetails.name"
                  :options="petNameOptions"
                  :rules="{ required: true }"
                  label="Pet's Home<em>Safe</em><sup>&reg;</sup> ID"
                  @input="handlePetNameSelect"
                />
                <h3 v-else class="text-dark font-weight-bold" v-html="$t('collars.h3text')" />
              </b-col>
              <b-col cols="12" xl="6" class="mt-3 mt-xl-0">
                <DpSelect
                  v-model="personalizationDetails.phone"
                  :options="phoneNumberOptions"
                  :rules="{ required: dropDownPhoneNumberSelected }"
                  label="Contact Number"
                  @input="handleContactNumberSelect"
                />
                <div class="mt-3">
                  <dp-input
                    v-if="!dropDownPhoneNumberSelected"
                    id="personalize-phone"
                    type="tel"
                    name="phone number"
                    inputmode="numeric"
                    autocomplete="tel"
                    validation-rules="required|phoneNumber"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    :value="formattedValue"
                    :placeholder="$t('personalize.option.name')"
                    :formatter="phoneNumberFormatter"
                    :aria-label="$t('personalize.option.name')"
                    :validation-state="validated ? 'valid' : null"
                    @input="setPhone"
                  />
                </div>
              </b-col>
            </b-row>
          </section>
        </div>
      </b-form-group>
      <ValidationProvider v-slot="{ errors }" vid="p-personalization-select" :rules="{ required: false }" slim>
        <input v-model="personalizationDetails.selected" type="text" class="d-none" hidden />
        <span v-if="errors && errors[0]" class="text-danger">{{ $t('personalize.option.error') }}</span>
      </ValidationProvider>
    </ValidationObserver>
  </section>
</template>

<script>
import DpInput from '@/components/library/Input';
import DpSelect from '@/components/library/Select';
import CollarLeashPersonalizePreview from './CollarLeashPersonalizePreview';
import { PersonalizationMixins } from '../../mixins/components/personalization';

export default {
  name: 'CollarLeashPersonalize',
  components: {
    CollarLeashPersonalizePreview,
    DpSelect,
    DpInput,
  },
  mixins: [PersonalizationMixins],
  computed: {
    titleKey() {
      const numPrice = Number(this.price);
      if (!this.isAdmin && this.price != null && !Number.isNaN(numPrice) && numPrice === 0) {
        return 'collarPersonalize.title.free';
      }
      return !this.isAdmin ? 'collarPersonalize.title.default' : 'collarPersonalize.title.admin';
    },
    petNameOptions() {
      const options = [{ value: '', text: 'Select Pet' }];
      if (this.petOwner) {
        this.petOwner?.pets?.forEach((pet) => {
          options.push({ value: `${pet.name}`, text: `${pet.name} [${pet.idCode}]` });
        });
      }
      return options;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-control h2 {
  padding-top: 2px;
}
.personalize-img {
  margin-left: -2rem;
}
.personalize-text {
  text-overflow: scale;
}
p {
  font-size: 1.3rem;
  line-height: 1.3;
}
</style>
<style lang="css">
.dropdown .dropdown-menu {
  z-index: 9999 !important;
}
</style>
